import { initContract } from "@ts-rest/core";
import { z } from "zod";

export interface TransactionForReconciliation {
    date: string;
    bankDescription: string;
    amount: number;
}

export interface TransactionForReconciliationFromAccount
    extends TransactionForReconciliation {
    financialTransactionId: number;
}

export interface TransactionForReconciliationFromStatement
    extends TransactionForReconciliation {
    financialDocumentId: number;
    row: number;
}

export interface TransactionsPairForReconciliation {
    fromStatement?: TransactionForReconciliationFromStatement;
    fromAccount?: TransactionForReconciliationFromAccount;
}

export interface ReconciliationSummaryResponse {
    transactionsPairs: TransactionsPairForReconciliation[];
    statementsOpeningBalance: number;
    statementsOpeningDate: string;
    statementsClosingBalance: number;
    statementsClosingDate: string;
}

const c = initContract();
export const reconciliationContract = c.router(
    {
        getReconciliationSummary: {
            method: "GET",
            path: "/summary",
            query: z.object({
                financialAccountId: z.coerce.number(),
                workspaceId: z.string().uuid(),
            }),
            responses: {
                200: c.type<ReconciliationSummaryResponse>(),
            },
        },
        reconcileTransactions: {
            method: "POST",
            path: "/reconcile",
            body: z.object({
                financialAccountId: z.number(),
                workspaceId: z.string().uuid(),
                financialTransactionsToRemove: z.array(z.number()),
                statementTransactionsToAdd: z.array(
                    z.object({
                        financialDocumentId: z.number(),
                        amount: z.number(),
                        date: z.string(),
                        bankDescription: z.string(),
                    }),
                ),
            }),
            responses: {
                200: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/reconciliation",
    },
);
